<div class="search">
    <div class="d-flex justify-content-center">
        <div class="search-txt">יש לסנן את הבחירה הרצויה לצורך קביעת מערכת שעות/חופשה לכיתה או לתלמיד</div>

    </div>

    <div class="search-content d-flex flex-column content">
        <div class="search-fields row g-0 p-0">

            <div class="search-warp col">
                <app-multi-select-search #filterClass [optionSetList]="calendarSvc.ClassesList" [placeholder]="'כיתה'" (optionsSelected)="optionSelected_Classes($event)">
                </app-multi-select-search>
            </div>
            <div class="search-warp col">
                <app-multi-select-search  #filterCode [optionSetList]="ClassAndCodeList" [placeholder]="'מספר כיתה'" (optionsSelected)="optionSelected_Numbers($event)">
                </app-multi-select-search>
            </div>
            <div class="search-warp col">
                <app-multi-select-search  #filterType [optionSetList]="calendarSvc.ClassificationList" [placeholder]="'סוג תגבור'" (optionsSelected)="optionSelected_Types($event)">
                </app-multi-select-search>
            </div>
            <div class="search-warp col">
                <app-multi-select-search  #filterAfternoon [optionSetList]="afternoon" [placeholder]="'צהרון'" [boolean]="true" (optionsSelected)="optionSelected_Afternoon($event)">
                </app-multi-select-search>
            </div>
            <div class="search-warp col">
                <ng-select #filterCamp [items]="calendarSvc.CampList" bindLabel="viewValue" bindValue="value" notFoundText="לא נמצאו ערכים" (change)="optionSelected_Camp($event)">
                </ng-select>
                <!-- <app-multi-select-search  #filterCamp [optionSetList]="calendarSvc.CampList" [placeholder]="'קייטנה'" (optionsSelected)="optionSelected_Camp($event)">
                </app-multi-select-search> -->
            </div>
            <div class="col">
                <div class="desktopBtn search-btn">
                    <button (click)="clearFilter()">איפוס מסננים</button>
                </div>
            </div>
        </div>

    </div>
</div>